/** @file tileColorAt: the straight-alpha colour of one pixel of a tile (the eyedropper). */
import type { Image, Rgba } from '@zilo/pose3d-image-io/types/image';

/** The RGBA at (`x`, `y`); null outside the image. */
export function tileColorAt(image: Image, x: number, y: number): Rgba | null {
  if (x < 0 || y < 0 || x >= image.width || y >= image.height) return null;
  const i = (y * image.width + x) * 4;
  const d = image.data;
  return [d[i] ?? 0, d[i + 1] ?? 0, d[i + 2] ?? 0, d[i + 3] ?? 0];
}
